


var swiperTreatment = new Swiper(".swiper-items-2", {
  loop: true,
  grabCursor: true,
  spaceBetween: 20,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  pagination: {
    el: ".swiper-pagination--treatment",
    clickable: true,
  },
  slidesPerView: 1,
  breakpoints: {
    768: {
      slidesPerView: 2,
    },
  },
});

const sliders = [
  { container: ".swiper-photo", pagination: ".swiper-pagination--photo" },
  { container: ".swiper-reviews", pagination: ".swiper-pagination--reviews" },
];

if (document.documentElement.clientWidth < 1024) {
  sliders.push({ container: ".swiper-advantages", pagination: ".swiper-pagination--reviews" });
  sliders.push({ container: ".swiper-really", pagination: ".swiper-pagination--really" });
  sliders.push({ container: ".swiper-methods", pagination: ".swiper-pagination--methods" });
  const advantagesCards = document.querySelector('.advantages-section__cards');
  const swiperMethods = document.querySelector('.methods-section__cards');

  const swiperReally = document.querySelector('.really-section__cards');
  if (advantagesCards) {
    advantagesCards.classList.remove('advantages-section__cards');
  }
  if (swiperReally) {
    swiperReally.classList.remove('really-section__cards');
  }
  if (swiperMethods) {
    swiperMethods.classList.remove('methods-section__cards');
  }
}

sliders.forEach(({ container, pagination }) => {
  new Swiper(container, {
    loop: true,
    grabCursor: true,
    spaceBetween: 20,
    navigation: {
      nextEl: `.swiper-button-next--${container.replace(/[\s.,%]/g, '')}`,
      prevEl: `.swiper-button-prev--${container.replace(/[\s.,%]/g, '')}`,
    },
    pagination: {
      el: `${pagination}`,
      clickable: true,
    },
    slidesPerView: 1,
    breakpoints: {
      320: { slidesPerView: 1 },
      768: { slidesPerView: 2 },
      1024: { slidesPerView: 4 },
    },
  });
});
